export default "__VITE_ASSET__Bj4AAJ6p__"